import Vue from 'vue';
import VeeValidate from 'vee-validate';

// Vue.use(VeeValidate);

Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields',
});
